import React, { Component } from "react";
import moment from "moment";
import * as Constants from "../../common/Global/constants";
import * as TemplateConstants from "../../common/Global/templateConstants";
import AlertDialog from "../../common/AlertDialog";
import AlertWithTextareaDialog from "../../common/AlertDialog/alertwithTextarea";
import Pagination from "../../common/Global/pagination";
import RegularDropDown from "../../common/DropdownMenus/RegularDropdown";
import {
    getLocalStorageVariables,
    getThemeSettingsVariables,
    isEmptyVariable,
    isEmptyArray,
    isJsonString,
    handleTokenExpiry,
    hasFeatureAccess,
    getSettingStatus,
    removeHtmlTags,
    getTrimmedText,
    getClientResponseDeadlineBadge
} from "../../common/Global/commonFunctions";
import { BrowserRouter as Router } from "react-router-dom";
import { Modal } from "react-bootstrap";
import AuditeeSidebar from "../../common/AuditeeSidebar";
import AuditeeTopbar from "../../common/AuditeeTopbar";
import MasterMenuTabs from "./topmenu";
import UploadAnnexureDialog from "./UploadAnnexure";
import AddNewResponseDialog from "./addNewResponseDialog";
import ViewResponseCommentDialog from "./viewResponseCommentsdialog";
// import ReAssignForResponse from "./reAssignForResponse";
import { TableCheckBox, DialogProceedButton } from "../../common/Global/globalStyles.style";

const defaultWeightPlaceholder = "Rank";
const defaultYNPlaceholder = "Rank";
let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
class AuditeeTasksList extends Component {
    constructor(props) {
        super(props);
        const item = props.location.state;
        this.state = {
            componentDidMountFlag: false,
            apiSearchKey: "",
            searchkey: "",
            currentPageNo: 1,
            showLoader: false,
            resultSize: Constants.RESULT_SIZE,
            totalCount: 0,
            datalist: [],
            resultSizePlaceholder: Constants.RESULT_SIZE,
            sort: "",
            sortDir: "",
            company:{},

            showAlertDialog: false,
            operationType: "",
            deleteReactivateId: "",
            deleteReactivateMasterType: "",
            reviewLevel: "",
            alertDialogMessage: "",
            alertDialogHeading: "",
            proceedBtnLabel: "",
            showBtnLoader:false,
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",
            assignmentId: this.props.match.params.id,
            unitListId: item?.unitListId || [],
            executionTemplateId: item?.executionTemplateId || "",
            resultSizeArr: Constants.RESULT_SIZE_DD_ARR,
            isAllowReassignTaskByClientEnabled:false,

            showReassignEmployeeModal: false,
            reassignModalTaskItem: null,
            reassignSelectedEmployee: null,
            reassignEmployeesList: [],
            reassignEmployeesLoaded: false,
            reassignSearchText: "",
            reassignSaving: false,

            execTaskTemplateFields:[],
            executionTemplateValueMap:{},
            executionTemplateFixedFields:{},

            selectedTaskTemplateFields:[],

            assignmentArea:"",
            assignmentDetails:{},
            allSettings:[],
            isRisk:false,
            isLikelihood:false,
            isTemplateSettingRisk:false,

            showWeight:false,
            showRanking:false,
            showYesNoDD:false
        };
        this.masterTypeFilterArr = [];
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount() {
        this.getInitData();
    }

    uploadAnnexuresBackupIconClick = (assignmentTaskId, annexureList) => {
	    this.setState({
	    	showSelectUploadAnnexureDialog: true,
	    	deleteReactivateId:assignmentTaskId,
            annexureList:annexureList
	    });
    }

    handleSelectUploadAnnexureDialogClose = () => {
		this.setState({
			showSelectUploadAnnexureDialog: false,
            deleteReactivateId:"",
            annexureList:[]
		});
	};

    showAuditeeResponseDialogonClick = (assignmentTaskId,auditeeResponseCount,observationId,clientResponseDeadline) =>{
        let tmpShowAddResponseDialog = false;
        let tmpShowViewResponseDialog = false;

        if(auditeeResponseCount!==0){
            tmpShowViewResponseDialog = true
            tmpShowAddResponseDialog = false
        }else{
            tmpShowViewResponseDialog = false
            tmpShowAddResponseDialog = true;
        }

        this.setState({
            observationId:observationId,
            showAddResponseDialog:tmpShowAddResponseDialog,
            showViewResponseDialog:tmpShowViewResponseDialog,
            selectedAssignmentTaskId:assignmentTaskId,
            selectedClientResponseDeadline:clientResponseDeadline
        })
    }

    handleAddResponseDialogClose = (reloadFlag) =>{
        this.setState({
            showAddResponseDialog:false
        },()=>{
            if (reloadFlag == true) this.getInitData();
        })
    }

    handleViewResponseDialogClose = () => {
        this.setState({
            showViewResponseDialog:false
        })
    }

    // handleReAssignForResponse = () => {
    //     this.setState({
    //         showReAssignForResponse:true
    //     })
    // }

    // handleReAssignForResponseDialogClose = (reloadFlag) => {
    //     this.setState({
    //         showReAssignForResponse:false,
    //     },()=>{
    //         if(reloadFlag === true){
    //             this.getInitData();
    //         }
    //     })
    // }

    handleReassignIconClick = (taskItem) => {
        this.setState({
            showReassignEmployeeModal: true,
            reassignModalTaskItem: taskItem,
            reassignSelectedEmployee: null,
            reassignSearchText: ""
        });
        if(!this.state.reassignEmployeesLoaded){
            this.fetchReassignEmployees();
        }
    }

    handleReassignModalClose = () => {
        this.setState({
            showReassignEmployeeModal: false,
            reassignModalTaskItem: null,
            reassignSelectedEmployee: null
        });
    }

    handleReassignEmployeeClick = (employee) => {
        this.setState({ reassignSelectedEmployee: employee });
    }

    fetchReassignEmployees = () => {
        fetch(Constants.EmployeeOrAuditeeList,{
            method:"POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                assignmentId:this.state.assignmentId,
                userType:'ae'
            })
        })
        .then(response => response.json())
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            if(data.responseCode === Constants.CODE_SUCCESS){
                const draftAssignmentAuditeeList = data.data.draftAssignmentAuditeeList || [];
                const clientEmployeeList = data.data.clientEmployeeList || [];

                const matchingAssignmentUnit = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0];
                    return this.state.unitListId.includes(unitId);
                });
                const otherEmployees = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0];
                    return !this.state.unitListId.includes(unitId);
                });

                const employees = [...draftAssignmentAuditeeList, ...matchingAssignmentUnit, ...otherEmployees];
                const employeesList = employees
                    .map(emp => ({
                        ...emp,
                        fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                    }))
                    .filter(emp => emp.employeeEmail !== userDetails.email);

                this.setState({
                    reassignEmployeesList: employeesList,
                    reassignEmployeesLoaded: true
                });
            }
        });
    }

    handleReassignSearchChange = (e) => {
        this.setState({ reassignSearchText: e.target.value });
    }

    handleReassignSave = () => {
        const taskItem = this.state.reassignModalTaskItem;
        const employee = this.state.reassignSelectedEmployee;
        if(isEmptyVariable(taskItem) || isEmptyVariable(employee)) return;

        this.setState({ reassignSaving: true });

        let aeList = JSON.stringify([{
            employeeId: employee.employeeId,
            employeeType: employee.employeeType,
            assignmentTaskId: taskItem.assignmentTaskId
        }]);

        fetch(Constants.ReAssign, {
            method:"POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                aeList:aeList,
                assignmentId:this.state.assignmentId,
                clientResponseDeadline: taskItem.clientResponseDeadline || ""
            })
        })
        .then(response => response.json())
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            this.setState({ reassignSaving: false });
            if(data.responseCode === Constants.CODE_SUCCESS){
                this.handleReassignModalClose();
                this.getInitData();
            }else{
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage
                })
            }
        });
    }

    handleAcceptTaskClick = (assignmentTaskId) => {
        this.setState({
            showAlertDialog: true,
            operationType: "Accept",
            deleteReactivateId: assignmentTaskId,
            alertDialogHeading: "Accept Task",
            alertDialogMessage: "Are you sure you want to accept this task?",
            proceedBtnLabel: "Accept",
        });
    }

    handleRejectTaskClick = (assignmentTaskId) => {
        this.setState({
            showAlertTextareaDialog: true,
            operationType: "Reject",
            deleteReactivateId: assignmentTaskId,
            alertDialogHeading: "Reject Task",
            alertDialogMessage: "Are you sure you want to reject this task?",
            proceedBtnLabel: "Reject",
        });
    }

    handleAlertDialogClose = () => {
        this.setState({
            showAlertTextareaDialog: false,
            operationType: "",
            deleteReactivateId: "",
        });
    }

    handleAlertTextAreaDialogClose = () => {
        this.setState({
            showAlertTextareaDialog: false,
            operationType: "",
            deleteReactivateId: "",
        });
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({ showAlertDialogInfo: false });
    }

    handleRecordOperation = (remarks) => {
        const { operationType, deleteReactivateId } = this.state;
        const status = operationType === "Accept" ? "accepted" : "rejected";

        this.setState({ showBtnLoader: true });

        const bodyParams = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            assignmentTaskId: deleteReactivateId,
            acceptedStatus: status,
        };

        if (operationType === "Reject" && remarks) {
            bodyParams.acceptedStatusRemarks = remarks;
        }

        const body = new URLSearchParams(bodyParams);

        fetch(Constants.AcceptedStatus, {
            method: "POST",
            mode: "cors",
            body: body,
        })
        .then(res => res.json())
        .then(res => {
            if (handleTokenExpiry(res.responseCode)) return;
            if (res.responseCode === Constants.CODE_SUCCESS) {
                this.setState({ showAlertDialog: false, showAlertTextareaDialog:false, showBtnLoader: false }, () => {
                    this.getInitData();
                });
            } else {
                this.setState({
                    showBtnLoader: false,
                    showAlertDialog: false,
                    showAlertDialogInfo: true,
                    showAlertTextareaDialog:false,
                    alertDialogMessageInfo: res.responseMessage,
                });
            }
        });
    }

    getExecutionFieldDisplayValue = (assignmentTaskId, field) => {
        const raw = this.state.executionTemplateValueMap?.[assignmentTaskId]?.[field.fieldId];
        return this.getFieldDisplayValue(raw, field);
    }

    getTaskTemplateFieldDisplayValue = (taskId, field) => {
        const raw = this.state.taskTemplateValuesMap?.[taskId]?.[field.fieldId];
        return this.getFieldDisplayValue(raw, field);
    }

    getFieldDisplayValue = (raw, field) => {
        if(!raw || raw.valueNR === "Y" || isEmptyVariable(raw.value)){
            return "-";
        }

        switch(field.fieldType){
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT: {
                if(!isJsonString(raw.value)) return "-";
                const parsed = JSON.parse(raw.value);
                return isEmptyArray(parsed) ? "-" : parsed.join(", ");
            }
            case TemplateConstants.FIELD_TYPE_TABLE: {
                if(!isJsonString(raw.value)) return "-";
                const parsed = JSON.parse(raw.value);
                return isEmptyArray(parsed)
                    ? "-"
                    : <table className="table instances-table" style={{marginBottom:0}}>
                        <tbody>
                            {parsed.map((rowItem, rowIndex) => (
                                <tr key={rowIndex}>
                                    {rowItem.map((colItem, colIndex) => (
                                        colIndex !== rowItem.length - 1 &&
                                        (rowIndex === 0
                                            ? <th key={colIndex} className="text-center">{colItem}</th>
                                            : <td key={colIndex} className="text-center">{colItem}</td>)
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>;
            }
            case TemplateConstants.FIELD_TYPE_FRAMEWORK: {
                const clauses = Array.isArray(raw.value) ? raw.value : [];
                return isEmptyArray(clauses) ? "-" : clauses.map(c => c.frameworkClauseName).join(", ");
            }
            case TemplateConstants.FIELD_TYPE_DATE:
                return moment(raw.value).format("DD/MM/YYYY");
            default:
                return raw.value;
        }
    }

    isAllowReassignTaskByClientEnabled(tempTemplateSettings) {
        return (
            tempTemplateSettings &&
            tempTemplateSettings?.allowReassignTaskByClient &&
            tempTemplateSettings?.allowReassignTaskByClient.settingColumnEnabled === "Y"
        );
    }

    isRiskColumnEnabled = () => {
        return (
            this.state.isRisk &&
            this.state.executionTemplateFixedFields?.assignRisk === "Y" &&
            this.state.isTemplateSettingRisk &&
            hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) &&
            (!isEmptyVariable(this.state.assignmentDetails.riskId) || !isEmptyVariable(this.state.assignmentDetails.likelihoodId))
        );
    }

    getTaskRiskDisplayValue = (taskItem) => {
        const { assignmentDetails, isLikelihood } = this.state;
        const showRisk = hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && !isEmptyVariable(assignmentDetails.riskId);
        const showLikelihood = isLikelihood && hasFeatureAccess(Constants.FEATURE_MATRIX_LIKELIHOOD) && !isEmptyVariable(assignmentDetails.likelihoodId);
        const risk = showRisk ? (isEmptyVariable(taskItem.assignmentTaskRiskLevel) ? "" : taskItem.assignmentTaskRiskLevel) : "";
        const likelihood = showLikelihood ? (isEmptyVariable(taskItem.assignmentTaskLikelihoodLevel) ? "" : taskItem.assignmentTaskLikelihoodLevel) : "";

        if(showRisk && showLikelihood){
            return (risk || likelihood) ? (risk + " / " + likelihood) : "";
        }else if(showRisk){
            return risk;
        }else if(showLikelihood){
            return likelihood ? (" / " + likelihood) : "";
        }
        return "";
    }

    getTaskYesNoRankDisplayValue = (taskItem) => {
        if(isEmptyVariable(taskItem.rank)){
            return defaultYNPlaceholder;
        }
        let label = defaultYNPlaceholder;
        Constants.yesNoRankArr.forEach((rankItem) => {
            if(taskItem.rank === rankItem.id){
                label = rankItem.label;
            }
        });
        return label;
    }

    getTaskRankDisplayValue = (taskItem) => {
        if(isEmptyVariable(taskItem.rank)){
            return defaultWeightPlaceholder;
        }
        return taskItem.rank === -1 ? "N/A" : taskItem.rank;
    }
    /*################################## EXEC TASK RELATED #################################*/
    getExecTableDataDisplayValue = (assignmentTaskId, fieldItem) => {
        if (isEmptyVariable(this.state.executionTemplateValueMap[assignmentTaskId])) {
            return "";
        }

        let fieldId = fieldItem.fieldId;
        if (isEmptyVariable(this.state.executionTemplateValueMap[assignmentTaskId][fieldId])) {
            return "";
        }

        let displayValue = this.state.executionTemplateValueMap[assignmentTaskId][fieldId]["value"];
        if (isEmptyVariable(displayValue)) {
            return "";
        }

        switch (fieldItem.fieldType) {
            case TemplateConstants.FIELD_TYPE_TEXT:
                return removeHtmlTags(displayValue);
            case TemplateConstants.FIELD_TYPE_DATE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_SINGLE_SELECT:
            case TemplateConstants.FIELD_TYPE_ISO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_DROPDOWN:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT:
                if (!isJsonString(displayValue)) {
                    return "";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                if (!isJsonString(displayValue)) {
                    return "";
                }
                return getTrimmedText(JSON.parse(displayValue).join(", "),20);
            case TemplateConstants.FIELD_TYPE_TABLE:
                if (!isJsonString(displayValue)) {
                    return "";
                }
                return JSON.parse(displayValue); 
            case TemplateConstants.FIELD_TYPE_NUMERIC:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_VALUE_ADDITION:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_YES_NO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_SCORE:
                return displayValue;
        }
        return "";
    };

    getExecTableDataDisplayValueNR = (assignmentTaskId, fieldItem) => {
        if (isEmptyVariable(this.state.executionTemplateValuesMap[assignmentTaskId])) {
            return "";
        }

        let fieldId = fieldItem.fieldId;
        if (isEmptyVariable(this.state.executionTemplateValuesMap[assignmentTaskId][fieldId])) {
            return "";
        }

        let displayValue = this.state.executionTemplateValuesMap[assignmentTaskId][fieldId]["valueNR"];
        if (displayValue === "Y") {
            return "Y";
        }else{
            return "N"
        }
    };

    getTaskDisplayValues = (taskId, fieldItem) => {
        if (isEmptyVariable(this.state.taskTemplateValuesMap[taskId])) {
            return "-";
        }

        let fieldId = fieldItem.fieldId;
        if (isEmptyVariable(this.state.taskTemplateValuesMap[taskId][fieldId])) {
            return "-";
        }

        let displayValue =
            this.state.taskTemplateValuesMap[taskId][fieldId]["value"];
        if (isEmptyVariable(displayValue)) {
            return "-";
        }

        switch (fieldItem.fieldType) {
            case TemplateConstants.FIELD_TYPE_TEXT:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_DATE:
                return isEmptyVariable(displayValue)
                    ? ""
                    : moment(displayValue).format("DD/MM/YYYY");
            case TemplateConstants.FIELD_TYPE_SINGLE_SELECT:
            case TemplateConstants.FIELD_TYPE_ISO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_DROPDOWN:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT:
                if (!isJsonString(displayValue)) {
                    return "-";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                if (!isJsonString(displayValue)) {
                    return "-";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_NUMERIC:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_VALUE_ADDITION:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_YES_NO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_SCORE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_FRAMEWORK:
                // 1. Group the framework clauses by frameworkName
                try {
                    const frameworkArray = displayValue;
                    const groupedData = frameworkArray.reduce((acc, item) => {
                        // Use frameworkId or frameworkName for grouping
                        const key = item.frameworkName;
                        if (!acc[key]) {
                            acc[key] = {
                                name: item.frameworkName,
                                clauses: []
                            };
                        }
                        // Extract and clean the clause name
                        let clauseName = item.frameworkClauseName.trim();
                        const shortNameWithSpace = ' ' + item.frameworkShortName;

                        // Clean up the clause name (e.g., remove " PAF" from "Clause 4.4.1 PAF")
                        if (clauseName.endsWith(shortNameWithSpace)) {
                            clauseName = clauseName.substring(0, clauseName.lastIndexOf(shortNameWithSpace)).trim();
                        }
                        acc[key].clauses.push({
                            name: clauseName,
                            order: item.frameworkClauseOrder,
                            frameworkClauseItem: item // Keep the full item for info icon binding
                        });
                        return acc;
                    }, {});

                    // Get the list of framework groups (for checking single vs. multiple)
                    const frameworkGroups = Object.values(groupedData);

                    // Check if only one framework is used (based on the grouped data count)
                    const isSingleFramework = frameworkGroups.length === 1;

                    // 2. Format the grouped data into the required string array
                    const formattedStrings = frameworkGroups.map((group, index) => {
                        // Sort clauses based on their original order
                        const sortedClauses = group.clauses.sort((a, b) => a.order - b.order);

                        // Generate an array of JSX elements, each containing the clause name, its info icon, and a separator
                        const clauseElements = sortedClauses.flatMap((clause, clauseIndex) => {
                            const elements = [
                                <div 
                                    key={`clause-item-${index}-${clauseIndex}`} 
                                    className="d-flex align-items-center" // Use flex to keep name, icon, separator inline
                                >
                                    {/* 1. Clause Name */}
                                    <span 
                                        className="task-dangerouslysethtml framework-inline" 
                                        dangerouslySetInnerHTML={{ __html: ` ${clause.name}` }} 
                                    />
                                    {/* 2. Info Icon for the Clause */}
                                    <div
                                        key={`info-${index}-${clauseIndex}`}
                                        className="tool hover-item framework-info-icon"
                                        data-title="Clause Details"
                                    >
                                        <span
                                            onClick={this.frameworkClauseInfo.bind(this, clause.frameworkClauseItem, group.name)}
                                            className="material-icons-outlined framework-icon"
                                            style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                                        >
                                            info
                                        </span>
                                    </div>
                                </div>
                            ];

                            // 3. Add a separator (comma and space) if it's not the last clause
                            if (clauseIndex < sortedClauses.length - 1) {
                                elements.push(
                                    <span key={`sep-${index}-${clauseIndex}`} className="framework-clause-separator">
                                        ,&nbsp;
                                    </span>
                                );
                            }

                            return elements;
                        });

                        return (
                            <div key={index} className="framework-line-container">
                                <div className="framework-group-line d-flex">
                                    <div className="framework-text-content-combined d-flex flex-wrap align-items-center">
                                        {/* Conditional Display of Framework Name */}
                                        {!isSingleFramework && (
                                            <span className="framework-name-text">
                                                {group.name}&nbsp;
                                            </span>
                                        )}
                                        {/* Render the array of clause names and icons */}
                                        <div className="framework-clauses-container d-flex flex-wrap">
                                            {clauseElements}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    });
                    return formattedStrings;
                } catch (error) {
                    return displayValue;
                }
        }
        return "-";
    };

    // Add this helper function inside your component class
    getTotalCombinations = (fieldItem, taskId) => {
        // Return a very large number if descriptions are used, to ensure the dropdown is shown.
        if (fieldItem?.descriptions && Object.keys(fieldItem.descriptions).length > 0) {
            return Object.keys(fieldItem.descriptions).length;
        }

        let step = 1;
        switch (fieldItem.decimalValue) {
            case "tenth": step = 0.1; break;
            case "quarter": step = 0.25; break;
            case "half": step = 0.5; break;
            case "any": return 1000; // For 'any', it's effectively infinite, so treat as > 9
            default: step = 1;
        }
        let displayValue = 0;
        if(this.state.hasTaskTemplateScore){
            let selectedTemplatefieldId = this.state.selectedTaskTemplateFields.find(item => item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE)
            displayValue = this.state.taskTemplateValuesMap[taskId]?.[selectedTemplatefieldId.fieldId]?.["value"];
        }
        if(!isEmptyVariable(displayValue)){
            displayValue = displayValue;
        }
        const maxScore = this.state.hasTaskTemplateScore ? displayValue : fieldItem.maximumScore;

        // Calculate total possible values: (score range / step) + 1 for the zero value
        const count = (maxScore / step) + 1;
        return count;
    };

    generateScoreDropdown = (fieldItem,taskId) => {
        let step = 1;
        switch (fieldItem.decimalValue) {
          case "tenth":
            step = 0.1;
            break;
          case "quarter":
            step = 0.25;
            break;
          case "half":
            step = 0.5;
            break;
          case "any":
            step = 0.01; // show only whole numbers in popup
            break;
          default:
            step = 1;
        }
        // generate all possible values
        let values = [];
        let displayValue = 0;
        if(this.state.hasTaskTemplateScore){
            let selectedTemplatefieldId = this.state.selectedTaskTemplateFields.find(item => item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE)
            displayValue = this.state.taskTemplateValuesMap[taskId]?.[selectedTemplatefieldId.fieldId]?.["value"];
        }
        if(!isEmptyVariable(displayValue)){
            displayValue = displayValue;
        }
        const maxScore = this.state.hasTaskTemplateScore ? displayValue : fieldItem.maximumScore;

        for (let i = 0; i <= maxScore; i += step) {
          values.push(Number(i.toFixed(2)));
        }
        
        // Take Only first 9 values
        values = values.slice(0, 9);
        // Map the initial values using a ternary operator for cleaner logic
        const dropdownOptions = values.map(v => (
            fieldItem?.descriptions
                ? {
                    value: v,
                    description: `${v} - ${fieldItem.descriptions[v] || ""}`,
                    displayDescription: fieldItem.descriptions[v] || ""
                }
                : { value: v }
        ));

        // Create the 'N/A' option, conditionally adding description properties
        const naOption = {
            value: "N/A",
            ...(fieldItem?.descriptions && { description: "N/A", displayDescription: "N/A" })
        };

        // Append the 'N/A' option and return the final array
        return [...dropdownOptions, naOption];
    };

    getExecTaskDisplayTableData = (assignmentTaskId,fieldItem,assignmentTaskAllowEdit,taskId,leafNodeId,functionId,processId) => {
        switch (fieldItem.fieldType) { 
            case TemplateConstants.FIELD_TYPE_TEXT:
            case TemplateConstants.FIELD_TYPE_NUMERIC:
            case TemplateConstants.FIELD_TYPE_VALUE_ADDITION:
                return (
                    <td style={{height:"100%"}}>
                        <div
                            contenteditable={"false"}
                            className="exec-task-text-field"
                        >
                            {this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem)}
                        </div>
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_DATE:
                let displayLabelDate = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                return (
                    <td>
                        {!isEmptyVariable(displayLabelDate) ? displayLabelDate : ""}
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_SINGLE_SELECT:
            case TemplateConstants.FIELD_TYPE_ISO:
                let displayLabel = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                let displayLabelNR = this.getExecTableDataDisplayValueNR(
                    assignmentTaskId,
                    fieldItem
                );
                let newFieldItem = {
                    fieldValue: displayLabel,
                    fieldValueNR: displayLabelNR,
                    ...fieldItem,
                };
                
                return (
                    <td>
                        {displayLabelNR == "Y"?"NA":displayLabel}
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT:
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                let displayLabelMulti = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                let displayLabelMulitArr = displayLabelMulti.split(", ");
                let displayLabelMultiNR = this.getExecTableDataDisplayValueNR(
                    assignmentTaskId,
                    fieldItem
                );

                let newFieldItemMulti = {
                    fieldValue: displayLabelMulitArr,
                    fieldValueNR: displayLabelMultiNR,
                    ...fieldItem,
                };
                
                return (
                    <td>
                        {displayLabelMultiNR == "Y"?"NA":displayLabelMulti.includes('Other')?displayLabelMulti.replace('Other:-:', '').trim():displayLabelMulti}
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_TABLE:
                let parsedJsonTableObj = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                let displayLabelTableNR = this.getExecTableDataDisplayValueNR(
                    assignmentTaskId,
                    fieldItem
                );

                let newFieldItemTable = {
                    ...fieldItem,
                    fieldValue: parsedJsonTableObj,
                    fieldValueNR: displayLabelTableNR,
                };
                return (
                    <td>
                        {
                            displayLabelTableNR == "Y"
                            ?"NA"
                            :(isEmptyVariable(parsedJsonTableObj) ? "-" : this.getAssignmentTaskExecTable(parsedJsonTableObj))
                        }
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_YES_NO:
                let displayLabelYesNo = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                // Use dropdown values from fieldItem
                const yesNoOptions = fieldItem.dropdownValues || [];
                return (
                    <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {isEmptyVariable(displayLabelYesNo) ? fieldItem.placeholderValue : displayLabelYesNo}
                        </div>
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_SCORE:
                const totalCombinations = this.getTotalCombinations(fieldItem, taskId);
                const scoreValue = this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem);
                const description = (fieldItem.isDecimalAllowed === "Y" && fieldItem?.descriptions)
                    ? this.generateScoreDropdown(fieldItem, taskId).find(item => String(item.value) === String(scoreValue))?.displayDescription
                    : null;
                let displayValue = 0;
                if(this.state.hasTaskTemplateScore){
                    let selectedTemplatefieldId = this.state.selectedTaskTemplateFields.find(item => item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE)
                    displayValue = this.state.taskTemplateValuesMap[taskId]?.[selectedTemplatefieldId.fieldId]?.["value"];
                }
                if(!isEmptyVariable(displayValue)){
                    displayValue = displayValue;
                }
                const maximumScore = this.state.hasTaskTemplateScore ? displayValue : fieldItem.maximumScore;

                // const maximumScore = fieldItem.maximumScore;
                const scoreOptions = [];

                for (let i = 1; i <= maximumScore; i++) {
                    scoreOptions.push({
                        value: i,
                        label: String(i) // The label is the string representation of the value
                    });
                }
                // Add the final "N/A" option
                scoreOptions.push({
                    // Use a value that won't conflict with your numeric scores, 
                    // like null, 0, or a specific string (e.g., 'NA').
                    value: 'N/A', 
                    label: 'N/A' 
                });
                let decimalMultiple;
                let displayDecimalVal = fieldItem.decimalValue
                switch (displayDecimalVal) {
                    case 'tenth':
                        decimalMultiple = .1;
                        break;
                    case 'quarter':
                        decimalMultiple = .25;
                        break;
                    case 'half':
                        decimalMultiple = .5;
                        break;
                    default:
                        decimalMultiple = ''; // Default to "Any" or handle as an error
                        break;
                }
                return(
                    <>
                        {fieldItem.isDecimalAllowed === "Y" ?
                            <td style={{height:"100%"}}>
                                {totalCombinations > 9 ? (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div
                                                contenteditable={"true"}
                                                className="exec-task-text-field"
                                            >
                                                {this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem)}
                                            </div>
                                            <TableCheckBox
                                                themeSettings={themeSettings}>
                                                <input 
                                                    type="checkbox"
                                                    name={`${taskId}_${assignmentTaskId}`}
                                                    id={`${taskId}_${assignmentTaskId}`}
                                                    onChange={null}
                                                    checked={scoreValue === "N/A"}
                                                    disabled={true}
                                                />
                                                <label for={`${taskId}_${assignmentTaskId}`} 
                                                style={{marginLeft:-3}}></label>
                                            </TableCheckBox>
                                        </div>
                                        {this.state.focusedItemId === `${taskId}_${assignmentTaskId}` && (
                                            <div>Please insert a number from 0 to {fieldItem.maximumScore}. Decimals can be entered in a multiple of any {decimalMultiple}.</div>
                                        )}
                                    </>
                                ) : (
                                    <div className="score-cell">
                                        <span className="score-value">{scoreValue}</span>
                                        {description && description !== "N/A" && <span> {description}</span>}
                                    </div>
                                )}
                            </td>
                        : 
                        <td>
                            <RegularDropDown
                                placeholder={!isEmptyVariable(this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem))
                                    ? `${this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem)} ${!isEmptyVariable(description) && description !== "N/A" ? (description?.length > 10 ? description?.substring(0, 9) + "..." : description) : ""}`
                                    : fieldItem.placeholderValue
                                }
                                dropdownArr={scoreOptions}
                                labelParam={"value"}
                                onDropDownItemClick={null}
                                disabled={true}
                                defaultPlaceholderDropDown={fieldItem.placeholderValue}
                                themeSettings={themeSettings}
                                className={"score-dropdown"}
                                // clearSelectedValue={() => this.clearSelectedValue(taskId, assignmentTaskId, processId, functionId, fieldItem)}
                            />
                        </td>    
                    }
                    </>
                )
        }
    };

    renderSubTotal = (item, label) => {
        return this.renderTotalRow({
            label: label,
            itemList: item,
            isGrandTotal: false,
        });
    }
    
    renderGrandTotal = (idx) => {
        const { assignmentArea, datalist } = this.state;
        const dataSource = datalist;
        const filteredData = dataSource.filter(item => !isEmptyArray(item.taskList));
    
        const shouldRender = assignmentArea !== "Function"
            ? idx === (filteredData.length - 1)
            : idx === (
                this.getProcessGroupingTaskList(filteredData, assignmentArea)
            ).length - 1;
        return this.renderTotalRow({
            label: 'Grand Total',
            itemList: filteredData,
            isGrandTotal: true,
            shouldRender
        });
    }
    
    renderTotalRow = ({label, itemList, isGrandTotal = false, shouldRender = true }) => {
        const numericFields = this.state.execTaskTemplateFields.filter(field =>
            field.fieldType === TemplateConstants.FIELD_TYPE_NUMERIC ||
            field.fieldType === TemplateConstants.FIELD_TYPE_VALUE_ADDITION ||
            field.fieldType === TemplateConstants.FIELD_TYPE_SCORE
        );
        let hasTaskTemplateScore = this.state.selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE);
        let hasTaskTemplateWeightedScore = this.state.selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE);
    
        if (numericFields.length === 0 || !shouldRender) return null;
        return (
            <tr style={{fontWeight: "bold" }}>
                {this.state.assignmentArea == "Function" && this.state.showCheckboxColumnDataList && <td></td>}
                <td></td>
                <td></td>
                {
                    this.state.selectedTaskTemplateFields.map((item, taskIdx) => {
                        if(taskIdx === 0){
                            return(
                                <td style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                
                                {/* 2. Label Section: Apply a fixed width container */}
                                <div style={{ minWidth: '70px', marginRight: '30px' }}> 
                                    {/* The width of 'Grand Total' is wider than 'Sub Total', so 120px should cover it */}
                                    {`${label}`}
                                </div>
                                
                                {/* 3. "Max possible Score" Label */}
                                {/* Use minWidth here too for perfect column alignment with the scores */}
                                <div style={{ marginRight: '20px' }}>
                                    Max possible Score 
                                </div>
    
                                {/* 4. Scores Section: Displayed inline with a consistent gap */}
                                <div style={{ display: 'flex', gap: '20px' }}> 
                                    {this.state.execTaskTemplateFields.map(field => {
                                        if (field.fieldType === TemplateConstants.FIELD_TYPE_SCORE) {
                                            let ScoreFieldLength = this.state.execTaskTemplateFields.filter(f => f.fieldType === TemplateConstants.FIELD_TYPE_SCORE).length;
                                            const showFieldName = ScoreFieldLength > 1;
                                            
                                            const scoreValue = isGrandTotal
                                                ? this.state.totalScoreDetails?.grandTotalExecutionScore[field.fieldId]?.totalWeightedMaxScore
                                                : itemList?.subTotal?.executionScoreDetails?.[field.fieldId]?.totalWeightedMaxScore;
    
                                            // Conditionally construct the display string
                                            const displayString = showFieldName
                                                ? `${field.fieldName}: ${scoreValue}` // Shows "score: X"
                                                : `${scoreValue}`;   
                                            return(
                                                // Wrap the label and value in a span for a single score display
                                                <span key={field.fieldId}>
                                                    {/* {field.isDecimalAllowed !== "N" && */}
                                                        {!isEmptyVariable(displayString)?displayString:""}
                                                    {/* } */}
                                                </span>
                                            )
                                        }
                                        return null;
                                    })}
                                </div>
                            </td>
                            )
                        }
                        if(item.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE){
                            return (
                                <td key={item.fieldId}>
                                    {(hasTaskTemplateScore && hasTaskTemplateWeightedScore) &&
                                        (isGrandTotal ? this.state.totalScoreDetails?.grandTotalWeightedScore : itemList?.subTotal?.totalWeightedMaxScore)
                                    }
                                </td>
                            )
                        }
                        else if(item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE){
                            return (
                                <td>
                                    {!hasTaskTemplateWeightedScore && 
                                        (isGrandTotal ? this.state.totalScoreDetails?.grandTotalScore : itemList?.subTotal?.totalMaxScore)
                                    }
                                </td>
                            )
                        }
                        else{
                            return (
                                <td></td>
                            )
                        }
                    })
                }
                {this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" &&
                hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && this.state.isTemplateSettingRisk &&
                (!isEmptyVariable(this.state.assignmentDetails.riskId) || !isEmptyVariable(this.state.assignmentDetails.likelihoodId)) &&
                    <td></td>
                }
                {this.state.showWeight &&
                    <td></td>
                }
                {this.state.showYesNoDD &&
                    <td></td>
                }
                {this.state.showRanking &&
                    <td></td>
                }
                {this.state.execTaskTemplateFields.map(field => {
                    const isMultiSelect = field.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                      field.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT;
                    const shouldShowCell = !(isMultiSelect && field.isFromRiskMaster && field.isRiskMasterEnabled !== 'Y');
                    // Logic for Score Fields
                    if (field.fieldType === TemplateConstants.FIELD_TYPE_SCORE) {
                        // render the score and its optional description cell.
                        return (
                            <>
                                {/* {
                                    !this.state.hasTaskTemplateScore &&
                                    <td key={field.fieldId}></td>
                                } */}
                                {/* Cell for the score value */}
                                {/* {field.isDecimalAllowed !== "N" && */}
                                    <td key={field.fieldId}>
                                        {(() => {
                                            const source = isGrandTotal
                                                ? this.state.totalScoreDetails?.grandTotalExecutionScore[field.fieldId]
                                                : itemList?.subTotal?.executionScoreDetails[field.fieldId];
    
                                            if (!source) return "0/0.00%";
    
                                            const score = this.state.hasTaskTemplateWeightedScore
                                                ? source?.totalWeightedScore
                                                : source?.totalScore;
    
                                            const percentage = this.state.hasTaskTemplateWeightedScore
                                                ? source?.weightedPercentage
                                                : source?.percentage;
    
                                            return `${score || 0}/${!isEmptyVariable(percentage) ? percentage.toFixed(2) + "%" : "0.00%"}`;
                                        })()}
                                    </td>
                                {/* } */}
                                {/* Optional second cell for a score description */}
                                {/* {field.isDecimalAllowed === "Y" && field?.descriptions &&
                                    <td key={`${field.fieldId}-desc`}></td>
                                } */}
                            </>
                        );
                    }
    
                    // Logic for Numeric and Value Addition Fields
                    else if (
                        field.fieldType === TemplateConstants.FIELD_TYPE_NUMERIC ||
                        field.fieldType === TemplateConstants.FIELD_TYPE_VALUE_ADDITION
                    ) {
                        // Render a single cell with the calculated total.
                        return (
                            <td key={field.fieldId}>
                                {(() => {
                                    const { sum, total, hasFloat } = isGrandTotal
                                        ? this.getGrandTotal(itemList, [field], this.state.executionTemplateValuesMap)
                                        : this.getFieldTypeSum(itemList.taskList, [field], this.state.executionTemplateValuesMap);
                                    const value = isGrandTotal ? total : sum;
                                    return (hasFloat && value % 1 !== 0) ? value.toFixed(2) : parseInt(value, 10);
                                })()}
                            </td>
                        );
                    }
                    // For any other field type, render an empty cell to maintain table alignment.
                    else {
                        return (
                            shouldShowCell &&(
                                <td key={field.fieldId}></td>
                            )
                        );
                    }
                })}
                {
                    hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                    !isEmptyVariable(this.state.assignmentDetails.observationTemplateId) &&
                    <td></td>
                }
                {!isEmptyVariable(this.state.assignmentStatus) && this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_ONGOING &&
                    <td></td>
                }
            </tr>
        )
    }

    getProcessGroupingTaskList = (Datalist, assignmentArea) => {
        if (assignmentArea === "Function") {
            let tempProcessList = [];
            let processName = [];
            let tempAllDataList = Object.values(Datalist);
            Object.values(Datalist).map((item) => {
                Object.values(item.taskList).map((task) => {
                    if (!processName.includes(task.processNameList)) {
                        processName.push(task.processNameList)
                    }
                })
            })

            tempAllDataList.map((item) => {
                let tempTaskList = [];
                tempProcessList = [];
                let tempItem = item;
                let tempProcessId = "";
                processName.map((process) => {

                    tempTaskList = [];

                    Object.values(item.taskList).map((task) => {
                        tempProcessId = task.processIdList
                        if (task.processNameList === process) {
                            tempTaskList.push(task)
                        }

                    })

                    tempProcessList.push({
                        processName: process,
                        functionId: item.functionId,
                        functionName: item.functionName,
                        processId: tempProcessId,
                        taskList: tempTaskList
                    })
                    tempItem["processTaskList"] = tempProcessList
                })

            })
            return tempAllDataList
        }
        else {
            return Datalist
        }
    }
    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader: true
        });

        Promise.all([
            fetch(Constants.GetAuditeeEmployeeDraftReports+"/"+this.state.assignmentId+"/tasks", {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                }),
            }),
            fetch(Constants.GetTemplateSetting, {
                method: "POST",
                mode: 'cors',
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    templateId:this.state.executionTemplateId,
                    userType:'ae'
                })
            })
        ])
        .then(([masterRes,templateSettingsRes]) => {
            return Promise.all([masterRes.json(),templateSettingsRes.json()]);
        })
        .then(([masterRes,templateSettingsRes]) => {
            let datalistTemp = [];
            let selectedTaskTemplateFields = [];
            let execTaskTemplateFields = [];
            let taskTemplateValuesMap = {};
            let executionTemplateValueMap = {};
            let executionTemplateFixedFields = {};

            let assignmentRiskMatrix = [];
            let valueAdditions = [];
            let likelihoodRiskMatrix = [];
            let hasTaskTemplateScore = false;
            let hasTaskTemplateWeightedScore = false;
            let auditType = "";

            let assignmentDetails = {};
            let assignmentArea = "";
            let allSettings = [];
            let isRisk = false;
            let isLikelihood = false;
            let isTemplateSettingRisk = false;
            let showWeight = false;
            let showRanking = false;
            let showYesNoDD = false;

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if (masterRes.responseCode === Constants.CODE_SUCCESS) {
                datalistTemp = masterRes.data.assignedTaskList;
                assignmentDetails = masterRes.data.assignmentDetails || {};
                assignmentArea = assignmentDetails.assignmentArea || "";
                
                taskTemplateValuesMap = masterRes.data.taskTemplateValueMap;
                let selectedTaskTemplateFieldsStr = masterRes.data.executeTemplateDetails?.taskTemplateFields;
                if (
                    !isEmptyVariable(selectedTaskTemplateFieldsStr) &&
                    isJsonString(selectedTaskTemplateFieldsStr)
                ) {
                    selectedTaskTemplateFields = JSON.parse(
                        selectedTaskTemplateFieldsStr
                    );
                }
                allSettings = masterRes.data.allSettings || [];
                hasTaskTemplateScore = selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE);
                hasTaskTemplateWeightedScore = selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE);
                                    
                executionTemplateValueMap = masterRes.data.executeTemplateValueMap || {};
                let execTaskTemplateFieldsStr = masterRes.data.executeTemplateDetails?.templateFields;
                if (
                    !isEmptyVariable(execTaskTemplateFieldsStr) &&
                    isJsonString(execTaskTemplateFieldsStr)
                ) {
                    execTaskTemplateFields = JSON.parse(execTaskTemplateFieldsStr);
                }
                //EXEC TASK FIXED FIELDS
                let fixedTemplateFieldsStr =
                    masterRes.data.executeTemplateDetails?.fixedTemplateFields;
                if (
                    !isEmptyVariable(fixedTemplateFieldsStr) &&
                    isJsonString(fixedTemplateFieldsStr)
                ) {
                    executionTemplateFixedFields = JSON.parse(fixedTemplateFieldsStr);
                }
                
                isRisk = getSettingStatus(allSettings, Constants.DISABLEDRISK, "N", assignmentDetails.departmentId, assignmentDetails.assignmentTypeId);
                isLikelihood = getSettingStatus(allSettings, Constants.DISABLEDLIKELIHOOD, "N", assignmentDetails.departmentId, assignmentDetails.assignmentTypeId);
                isTemplateSettingRisk = getSettingStatus(allSettings, Constants.EXECUTION_TASK, "Y", assignmentDetails.departmentId, assignmentDetails.assignmentTypeId);

                if(!isEmptyArray(datalistTemp) && assignmentArea === "CheckList"){
                    let firstTaskList = datalistTemp[0].taskList;
                    if(!isEmptyArray(firstTaskList)){
                        if(firstTaskList[0].checkListType === "WR"){
                            showWeight = true;
                            showRanking = true;
                        }else if(firstTaskList[0].checkListType === "R"){
                            showRanking = true;
                        }else if(firstTaskList[0].checkListType === "Y/N"){
                            showYesNoDD = true;
                        }
                    }
                }
            } else {
            }

            let tempTemplateSettings = {};
            let isAllowReassignTaskByClientEnabled = false;

            if(handleTokenExpiry(templateSettingsRes.responseCode)) return;
            else if (templateSettingsRes.responseCode === Constants.CODE_SUCCESS) {
                tempTemplateSettings = templateSettingsRes.data[0]?.settingDetails ?? {};
                isAllowReassignTaskByClientEnabled = this.isAllowReassignTaskByClientEnabled(tempTemplateSettings);
            }else {
                tempTemplateSettings = ""
            }

            this.setState({
                componentDidMountFlag: true,
                showLoader:false,
                datalist: datalistTemp,
                selectedTaskTemplateFields:selectedTaskTemplateFields,
                taskTemplateValuesMap:taskTemplateValuesMap,
                execTaskTemplateFields:execTaskTemplateFields,
                executionTemplateValueMap:executionTemplateValueMap,
                executionTemplateFixedFields:executionTemplateFixedFields,
                
                assignmentArea:assignmentArea,
                assignmentDetails:assignmentDetails,

                allSettings:allSettings,
                isRisk:isRisk,
                isLikelihood:isLikelihood,
                hasTaskTemplateScore:hasTaskTemplateScore,
                hasTaskTemplateWeightedScore:hasTaskTemplateWeightedScore,

                isTemplateSettingRisk:isTemplateSettingRisk,
                showWeight:showWeight,
                showRanking:showRanking,
                showYesNoDD:showYesNoDD,
                isAllowReassignTaskByClientEnabled:isAllowReassignTaskByClientEnabled
            });
        })
    }
    /*******************API CALLS END HERE*******************/

    render() {
        const showRiskColumn = this.isRiskColumnEnabled();
        return (
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <AuditeeSidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <AuditeeTopbar />
                                <div className="d-flex align-items-center">
                                {/* <div className="flex-fill"> */}
                                <MasterMenuTabs
                                    themeSettings={themeSettings} 
                                    showTaskObservationTab={true}
                                    assignmentId={this.state.assignmentId}
                                    unitListId={this.state.unitListId}
                                    executionTemplateId={this.state.executionTemplateId}
                                />
                                {/* </div> */}
                                </div>
                                {this.state.showLoader && (
                                    <div class="loader"></div>
                                )}
                                {
                                    // Need to check component did mount flag, other wise until api is called,
                                    // it shows no items found layout.
                                    this.state.componentDidMountFlag &&
                                    !this.state.showReAssignForResponse &&  (
                                        <div className="body-wrapper">
                                            {/* {this.state.isAllowReassignTaskByClientEnabled &&
                                                <div className="search-addnew-bg">
                                                    <div className="search-addnew">
                                                        <div className="search-filter-layout"></div>
                                                        <div className="flex-center-layout">
                                                            <div className="bordered-anchor" style={{ textAlign: "right" }}>
                                                                <a onClick={this.handleReAssignForResponse} href="javascript:void(0)">
                                                                    <span className="material-icons"></span>
                                                                    <p>Re-Assign For Response</p>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            } */}
                                            <div className="common-table-scroll">
                                            {
                                                !isEmptyArray(this.state.datalist) && this.state.datalist.map((item, index) => {
                                                    return (
                                                        !isEmptyArray(item.taskList) &&
                                                        <div>
                                                            <div className="flex-center-layout" style={{ marginTop: index === 0 ? 15 : 10 }}>
                                                                <h6 style={{ marginTop: index == 0 ? 0 : 10 }} className="small-h6">
                                                                    {
                                                                        isEmptyVariable(item.processName)
                                                                        ?(isEmptyVariable(item.functionName)
                                                                            ?(item.heading)
                                                                            :item.functionName)
                                                                        :item.processName
                                                                    }
                                                                </h6>
                                                            </div>
                                                            {!isEmptyArray(item.taskList) &&
                                                                <div style={{ marginTop:10 }}>
                                                                    <div className="common-tab-bg">
                                                                        <div className="common-table" style={{ width: "100%" }}>
                                                                            <table className="table">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-center" width="38px">
                                                                                            No.
                                                                                        </th>
                                                                                        <th width="1%">
                                                                                            <div className="flex-center-layout justify-content-around">
                                                                                                {this.state.executionTemplateFixedFields?.annexures === "Y" && (
                                                                                                    <span className="tool" data-title="Annexure">A</span>
                                                                                                )}
                                                                                            </div>
                                                                                        </th>
                                                                                        {/* <th className="scrollable-table-task-text-th">Tasks</th> */}
                                                                                        {this.state.selectedTaskTemplateFields.map(field => (
                                                                                            <th key={field.fieldId} className={field.fieldType === TemplateConstants.FIELD_TYPE_TEXT ? "scrollable-table-task-text-th" : "scrollable-table-task-others-th"}>
                                                                                                {field.fieldName}
                                                                                            </th>
                                                                                        ))}
                                                                                        {
                                                                                            this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" &&
                                                                                            hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && 
                                                                                            this.state.isTemplateSettingRisk &&
                                                                                            (!isEmptyVariable(this.state.assignmentDetails.riskId)  || !isEmptyVariable(this.state.assignmentDetails.likelihoodId)) &&
                                                                                            <th>Risk</th>
                                                                                        }
                                                                                        {
                                                                                            this.state.showWeight &&
                                                                                            <th>Weight</th>
                                                                                        }
                                                                                        {
                                                                                            this.state.showYesNoDD &&
                                                                                            <th>Rate</th>
                                                                                        }
                                                                                        {
                                                                                            this.state.showRanking && 
                                                                                            <th>Rate</th>
                                                                                        }
                                                                                        {this.state.execTaskTemplateFields.map(field => {
                                                                                            let showHeader = true;
                                                                                                if (field.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                                                                                    field.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT) {
                                                                                                    if (field.isFromRiskMaster) {
                                                                                                        if (field.isRiskMasterEnabled === "Y") {
                                                                                                            showHeader = true;
                                                                                                        } else {
                                                                                                            showHeader = false;
                                                                                                        }
                                                                                                    } else {
                                                                                                        showHeader = true;
                                                                                                    }
                                                                                                }
                                                                                                let scoreHeading = true;
                                                                                                return (
                                                                                                    <>
                                                                                                    {showHeader &&
                                                                                                    <>
                                                                                                        {scoreHeading &&
                                                                                                            <th className={field.fieldType === TemplateConstants.FIELD_TYPE_TEXT
                                                                                                                ? "scrollable-table-task-text-th" : "scrollable-table-task-others-th"}>
                                                                                                                    {field.fieldName}
                                                                                                                    {field.isMandatorySelected === "Y" ? "*" : ""}
                                                                                                            </th>
                                                                                                        }
                                                                                                    </>
                                                                                                    }
                                                                                                </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                        <th width="110px">Deadline</th>
                                                                                        <th></th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {!isEmptyArray(item.taskList) &&
                                                                                    item.taskList.map((taskItem, idx) => {
                                                                                        let yNRank = defaultYNPlaceholder;
                                                                                        // For Y/N, get label from yesNoRankArr
                                                                                        if (this.state.showYesNoDD && !isEmptyVariable(taskItem.rank)) {
                                                                                            Constants.yesNoRankArr.forEach((rankItem) => { if (taskItem.rank === rankItem.id) { yNRank = rankItem.label; } });
                                                                                        }
                                                                                        const isAccepted = taskItem.acceptedStatus === "accepted";
                                                                                        const isRejected = taskItem.acceptedStatus === "rejected";
                                                                                        return (
                                                                                            <tr style={{ background: "#f5f5f5", }}>
                                                                                                <td className="text-center">
                                                                                                    {(this.state.currentPageNo - 1) * this.state.resultSize + (idx+1)}
                                                                                                </td>
                                                                                                <td>
                                                                                                    {
                                                                                                        this.state.executionTemplateFixedFields?.annexures === "Y" &&
                                                                                                        <span className="material-icons"
                                                                                                        style = {{
                                                                                                            color:taskItem.annexureCount===0?"#777777":
                                                                                                            `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                            opacity:taskItem.annexureCount===0?"0.6":"1"
                                                                                                        }}
                                                                                                        onClick={this.uploadAnnexuresBackupIconClick.bind(this,taskItem.assignmentTaskId,taskItem.annexureList)}>file_present</span>
                                                                                                    }
                                                                                                </td>
                                                                                                {
                                                                                                    this.state.selectedTaskTemplateFields.map((item, taskIdx) => {
                                                                                                        const isFramework = item.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK;
                                                                                                        const isText = item.fieldType === TemplateConstants.FIELD_TYPE_TEXT;
                                                                                                        const taskDisplayValues = this.getTaskDisplayValues(taskItem.taskId, item);
                                                                                                        return (
                                                                                                            <td
                                                                                                                style={taskIdx + "" === "0" ? { borderLeft: "5px solid " + (taskItem.fatal==="Y"?"#FF0000":taskItem.colorCode) } : {}} >
                                                                                                                <div className={item.fieldId + "" === "1" ? "dangerouslysethtml-flex" : ""}>
                                                                                                                    {isFramework ? (
                                                                                                                        <div className="task-framework-list">
                                                                                                                            {taskDisplayValues}
                                                                                                                        </div>
                                                                                                                    ) : (
                                                                                                                        <div 
                                                                                                                            className={`task-dangerouslysethtml`} 
                                                                                                                            dangerouslySetInnerHTML={{ __html: taskDisplayValues }} 
                                                                                                                        />
                                                                                                                    )}
                                                                                                                    {
                                                                                                                        taskItem.completionStatus === "Completed" && item.fieldId + "" === "1" && (
                                                                                                                            <span className="material-icons exec-task-done" >
                                                                                                                                done_all
                                                                                                                            </span>
                                                                                                                        )
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        );
                                                                                                    }
                                                                                                )}
                                                                                                {
                                                                                                    this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" && this.state.isTemplateSettingRisk &&
                                                                                                    hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && (!isEmptyVariable(this.state.assignmentDetails.riskId)  || !isEmptyVariable(this.state.assignmentDetails.likelihoodId)) &&
                                                                                                    <td>
                                                                                                        {
                                                                                                            (() => {
                                                                                                                const showRisk = hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && !isEmptyVariable(this.state.assignmentDetails.riskId);
                                                                                                                const showLikelihood = this.state.isLikelihood && hasFeatureAccess(Constants.FEATURE_MATRIX_LIKELIHOOD) && !isEmptyVariable(this.state.assignmentDetails.likelihoodId);
                                                                                                                const risk = showRisk ? (isEmptyVariable(taskItem.assignmentTaskRiskLevel) ? "" : taskItem.assignmentTaskRiskLevel) : "";
                                                                                                                const likelihood = showLikelihood ? (isEmptyVariable(taskItem.assignmentTaskLikelihoodLevel) ? "" : taskItem.assignmentTaskLikelihoodLevel) : "";
                                                                                                                if (showRisk && showLikelihood) {
                                                                                                                    if (risk && likelihood) {
                                                                                                                        return risk + " / " + likelihood;
                                                                                                                    } else if(!risk && !likelihood){
                                                                                                                        return "";
                                                                                                                    } else {
                                                                                                                        return risk +" / " + likelihood;
                                                                                                                    }
                                                                                                                } else if (showRisk && risk) {
                                                                                                                    return risk;
                                                                                                                } else if (showLikelihood && likelihood) {
                                                                                                                    return " / " + likelihood;
                                                                                                                } else {
                                                                                                                    return "";
                                                                                                                }
                                                                                                            })()
                                                                                                        }
                                                                                                    </td>
                                                                                                }
                                                                                                {
                                                                                                    this.state.showWeight && <td className="text-center"> {taskItem.weight} </td>
                                                                                                }
                                                                                                {
                                                                                                    this.state.showYesNoDD &&
                                                                                                    <td>
                                                                                                        {isEmptyVariable(taskItem.rank) ? defaultYNPlaceholder : yNRank}
                                                                                                    </td>
                                                                                                }
                                                                                                {
                                                                                                    this.state.showRanking &&
                                                                                                    <td>
                                                                                                        {isEmptyVariable(taskItem.rank) ? defaultWeightPlaceholder : taskItem.rank === -1 ? "N/A" : taskItem.rank}
                                                                                                    </td>
                                                                                                }
                                                                                                {
                                                                                                    this.state.execTaskTemplateFields.map((templateItem) => {
                                                                                                        let showHeader = true;
                                                                                                        if (templateItem.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                                                                                            templateItem.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT) {
                                                                                                            if (templateItem.isFromRiskMaster) {
                                                                                                                if (templateItem.isRiskMasterEnabled === "Y") {
                                                                                                                    showHeader = true;
                                                                                                                } else {
                                                                                                                    showHeader = false;
                                                                                                                }
                                                                                                            } else {
                                                                                                                showHeader = true;
                                                                                                            }
                                                                                                        }
                                                                                                        return showHeader && this.getExecTaskDisplayTableData(taskItem.assignmentTaskId, templateItem, false, 
                                                                                                            taskItem.taskId, this.state.assignmentArea == "CheckList" ? item.checkListHeadingId : item.processId, 
                                                                                                            "", taskItem.processIdList); 
                                                                                                    }
                                                                                                )}
                                                                                                <td className="text-center">
                                                                                                    {(() => {
                                                                                                        const deadlineBadge = getClientResponseDeadlineBadge(taskItem.clientResponseDeadline);
                                                                                                        return deadlineBadge ? (
                                                                                                            <div className="tool" data-title={deadlineBadge.tooltip}
                                                                                                                style={{
                                                                                                                    display:"inline-block",
                                                                                                                    padding:"3px 10px",
                                                                                                                    borderRadius:12,
                                                                                                                    fontSize:11, fontWeight:600, whiteSpace:"nowrap",
                                                                                                                    background:deadlineBadge.bgColor, color:deadlineBadge.textColor
                                                                                                                }}>
                                                                                                                {deadlineBadge.text}
                                                                                                            </div>
                                                                                                        ) : "-";
                                                                                                    })()}
                                                                                                </td>
                                                                                                <td>
                                                                                                    <div className="flex-center-layout justify-content-end" style={{ gap: 6 }}>
                                                                                                        {isAccepted ? (
                                                                                                            <div className="tool" data-title="Response">
                                                                                                                <span className="material-icons"
                                                                                                                    style={{
                                                                                                                        color: taskItem.auditeeResponseCount == 0 ? "#777777"
                                                                                                                            : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                        opacity: taskItem.auditeeResponseCount == 0 ? "0.6" : "1",
                                                                                                                        verticalAlign: "middle",
                                                                                                                        fontSize: 18,
                                                                                                                        cursor: "pointer"
                                                                                                                    }}
                                                                                                                    onClick={this.showAuditeeResponseDialogonClick.bind(this, taskItem.assignmentTaskId, taskItem.auditeeResponseCount, taskItem.observationId, taskItem.clientResponseDeadline)}>
                                                                                                                    rate_review
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        ) : (
                                                                                                            <div className="tool" data-title="Accept">
                                                                                                                <span className="material-icons"
                                                                                                                    style={{
                                                                                                                        color: `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                        verticalAlign: "middle",
                                                                                                                        fontSize: 18,
                                                                                                                        cursor: "pointer"
                                                                                                                    }}
                                                                                                                    onClick={this.handleAcceptTaskClick.bind(this, taskItem.assignmentTaskId)}>
                                                                                                                    check_circle
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        <div className="tool" data-title="Reject">
                                                                                                            <span className="material-icons"
                                                                                                                style={{
                                                                                                                    color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                    verticalAlign: "middle",
                                                                                                                    fontSize: 18,
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                                onClick={this.handleRejectTaskClick.bind(this, taskItem.assignmentTaskId)}>
                                                                                                                cancel
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        {this.state.isAllowReassignTaskByClientEnabled && (
                                                                                                            <div className="tool tool-right" data-title="Reassign to Employee">
                                                                                                                <span className="material-symbols-outlined"
                                                                                                                    style={{
                                                                                                                        color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                        verticalAlign: "middle",
                                                                                                                        fontSize: 18,
                                                                                                                        cursor: "pointer"
                                                                                                                    }}
                                                                                                                    onClick={() => this.handleReassignIconClick(taskItem)}>
                                                                                                                    chat_paste_go
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    })}
                                                                                </tbody>
                                                                                {this.renderSubTotal(item, "Sub Total")}
                                                                                {/* Grand Total row after last table */}
                                                                                {this.renderGrandTotal(index)}
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )
                                                })  
                                            }
                                            {this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
                                                <div class="no-items-layout">
                                                    <div class="no-items-card">
                                                        <h6>
                                                            {isEmptyVariable(this.state.apiSearchKey) ? Constants.NO_RECORDS_WARNING : Constants.EMPTY_SEARCH_WARNING}
                                                        </h6>
                                                    </div>
                                                </div>
                                            )}
                                            </div>
                                            <div className="pagination-layout">
                                                <div className="row custom-row">
                                                    <div className="col-md-9 custom-col">
                                                        {this.state.totalCount > this.state.datalist?.length && (
                                                            <Pagination
                                                                totalLength={this.state.totalCount}
                                                                items={this.state.datalist}
                                                                onChangePage={this.onChangePage}
                                                                pageSize={this.state.resultSize}
                                                                currentPageNo={this.state.currentPageNo}
                                                                initialPage={this.state.currentPageNo}
                                                                themeSettings={themeSettings}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="col-md-3 custom-col">
                                                        <p>{"Total Records: " + this.state.totalCount}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {/* {
                                    this.state.showReAssignForResponse &&
                                    <ReAssignForResponse
                                        handleReAssignForResponseDialogClose={this.handleReAssignForResponseDialogClose}
                                        assignmentId={this.state.assignmentId}
                                        unitListId={this.state.unitListId}
                                    />
                                } */}
                            </div>
                        </div>

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialog}
                            handleAlertDialogClose={this.handleAlertDialogClose}
                            type={
                                this.state.operationType === "Delete"
                                    ? Constants.ALERT_TYPE_WARNING
                                    : this.state.operationType === "Review Remarks"
                                    ? Constants.ALERT_TYPE_ALERT
                                    : Constants.ALERT_TYPE_INFO
                            }
                            alertDialogHeading={this.state.alertDialogHeading}
                            alertDialogMessage={this.state.alertDialogMessage}
                            proceedBtnClick={this.handleRecordOperation}
                            proceedBtnLabel={this.state.proceedBtnLabel}
                            showLoader={this.state.showBtnLoader}
                            themeSettings={themeSettings}
                        />

                        <AlertWithTextareaDialog
                            showAlertDialog={this.state.showAlertTextareaDialog}
                            handleAlertDialogClose={this.handleAlertTextAreaDialogClose}
                            alertDialogHeading={this.state.alertDialogHeading}
                            alertDialogMessage={this.state.alertDialogMessage}
                            proceedBtnClick={this.handleRecordOperation}
                            proceedBtnLabel={this.state.proceedBtnLabel}
                            showLoader={this.state.showBtnLoader}
                            themeSettings={themeSettings}
                        />

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                            themeSettings={themeSettings}
                        />
                        <UploadAnnexureDialog
                            showUploadAnnexureDialog={this.state.showSelectUploadAnnexureDialog}
                            handleSelectUploadAnnexureDialogClose={this.handleSelectUploadAnnexureDialogClose}
                            type={"Annexure"}
                            annexureList={this.state.annexureList}
                            assignmentTaskId={this.state.deleteReactivateId}
                            themeSettings={themeSettings}
                            isDraftOnward={false}
                            assignmentTaskAllowEdit={"N"}
                        />
                        <AddNewResponseDialog
                            showAddResponseDialog={this.state.showAddResponseDialog}
                            handleAddResponseDialogClose={this.handleAddResponseDialogClose}
                            themeSettings={themeSettings}
                            observationId={this.state.observationId}
                            assignmentId={this.state.assignmentId}
                            assignmentTaskId={this.state.selectedAssignmentTaskId}
                            isDraftOnward={this.props.isDraftOnward}
                        />
                        <ViewResponseCommentDialog
                            showViewResponseDialog={this.state.showViewResponseDialog}
                            handleViewResponseDialogClose={this.handleViewResponseDialogClose}
                            assignmentTaskId={this.state.selectedAssignmentTaskId}
                            assignmentId={this.state.assignmentId}
                            observationId={this.state.observationId}
                            themeSettings={themeSettings}
                            location={this.props.location}
                            isDraftOnward={this.props.isDraftOnward}
                            isClientResponseAfterCompletion={this.state.isClientResponseAfterCompletion}
                            allowEdit={this.props.allowEdit}
                        />
                        <Modal className="custom-dialog" show={this.state.showReassignEmployeeModal} backdrop="static">
                            <Modal.Header>
                                <h5>{"Reassign to Employee"}</h5>
                                <button
                                    onClick={this.handleReassignModalClose}
                                    type="button" data-dismiss="modal">
                                    <span class="material-icons">close</span>
                                </button>
                            </Modal.Header>
                            <div class="modal-body">
                                <div className="addnew-modal-form">
                                    {this.state.reassignSelectedEmployee &&
                                        <div class="addnew-modal-form-group">
                                            <div style={{
                                                padding:"8px 12px", borderRadius:6, fontWeight:600, fontSize:13,
                                                background:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},0.1)`,
                                                color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`
                                            }}>
                                                {this.state.reassignSelectedEmployee.fullName}
                                            </div>
                                        </div>
                                    }
                                    <div class="addnew-modal-form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search employee..."
                                            value={this.state.reassignSearchText}
                                            onChange={this.handleReassignSearchChange}
                                        />
                                    </div>
                                    <div class="addnew-modal-form-group" style={{maxHeight:220, overflowY:"auto"}}>
                                        {
                                            isEmptyArray(this.state.reassignEmployeesList) ? (
                                                <div style={{padding:"6px 8px", fontSize:13, color:"#777"}}>
                                                    {this.state.reassignEmployeesLoaded ? "No employees found" : "Loading..."}
                                                </div>
                                            ) : (
                                                this.state.reassignEmployeesList
                                                    .filter(emp => emp.fullName.toLowerCase().includes(this.state.reassignSearchText.toLowerCase()))
                                                    .map((emp, empIdx) => {
                                                        const isSelected = this.state.reassignSelectedEmployee?.employeeId === emp.employeeId
                                                            && this.state.reassignSelectedEmployee?.employeeType === emp.employeeType;
                                                        return (
                                                            <div key={empIdx}
                                                                style={{
                                                                    padding:"8px 10px", cursor:"pointer", fontSize:13, borderRadius:4,
                                                                    background: isSelected ? "#f0f0f0" : "transparent"
                                                                }}
                                                                onClick={() => this.handleReassignEmployeeClick(emp)}
                                                            >
                                                                {emp.fullName}
                                                            </div>
                                                        );
                                                    })
                                            )
                                        }
                                    </div>
                                </div>
                                <div class="dialog-btn-layout">
                                    <a class="alert-cancel" href="javascript:void(0);"
                                        onClick={this.handleReassignModalClose}
                                    >Cancel</a>
                                    <DialogProceedButton
                                        themeSettings={themeSettings}
                                        class="alert-proceed"
                                        href="javascript:void(0);"
                                        onClick={this.handleReassignSave}
                                        style={{
                                            marginLeft:"10px",
                                            opacity: isEmptyVariable(this.state.reassignSelectedEmployee) ? 0.5 : 1,
                                            pointerEvents: isEmptyVariable(this.state.reassignSelectedEmployee) ? "none" : "auto"
                                        }}
                                    >
                                        {this.state.reassignSaving ? <div class="loader-btn mt-2"></div> : "Save"}
                                    </DialogProceedButton>
                                </div>
                            </div>
                        </Modal>
                    </section>
                </main>
            </Router>
        );
    }
}

export default AuditeeTasksList;